import * as React from 'react';
import { applyTimezone, formatDate } from '../calendar.model';
import { dateFormatSettings, timeFormatSettings } from '../../settings/settings.consts';
import { resolveUserFormat, useUserFormatsVersion } from '../../common/user-formats/userFormats';

export const EventTime = ({ title, timezone, globalTimezone, date, user, formats }) => {
  useUserFormatsVersion();
  // Rem38 M7-ext v4 — `user.settings` is undefined on the Symfony Redux user
  // shape → `user.settings.date` threw `Cannot read properties of undefined
  // (reading 'date')` when this shared component is rendered from the W&B
  // manifest. Optional-chain + sensible defaults. Safe for all callers: when
  // `user.settings` exists (legacy), the result is identical. `timezone?.offset`
  // is likewise hardened (callers other than the manifest may pass undefined).
  // `formats` is passed by static renders that run outside the live tree.
  const dateFmt =
    dateFormatSettings[user?.settings?.date] ||
    resolveUserFormat('twigDateFormat', formats) ||
    'j M, Y';
  const timeFmt =
    timeFormatSettings[user?.settings?.time] ||
    resolveUserFormat('twigTimeFormat', formats) ||
    'H:i';
  const fmt = `${dateFmt} ${timeFmt}`;
  return (
    <div className="flex-column time-block">
      <span>
        <span className="title">{title}: </span>
        {formatDate(date, timezone?.offset, fmt)}
        {globalTimezone ? (
          <span className="text-muted">
            {formatDate(applyTimezone(date, globalTimezone.offset), 0, fmt)}{' '}
            [ {globalTimezone.abbr} {globalTimezone.name} {globalTimezone.offsetString} ]
          </span>
        ) : null}
      </span>
    </div>
  );
};
